import { createEntry } from './cacheEntry';
const compareHashes = (currentHash, nextHash, hashMode, logger) => {
  if (currentHash == null || nextHash == null) {
    return currentHash !== nextHash;
  }
  switch (hashMode) {
    case 'EQUAL':
      {
        return currentHash !== nextHash;
      }
    case 'GREATER':
      {
        return Number(nextHash) > Number(currentHash);
      }
    default:
      {
        logger === null || logger === void 0 || logger.error('encountered invalid hash mode', {
          hashMode
        });
        return true;
      }
  }
};
export const produceNextCacheEntry = ({
  params,
  hash,
  currentEntry,
  nextState,
  changeContext,
  logger
}) => {
  if (nextState === currentEntry.state || changeContext.changeId < currentEntry.meta.changeContext.changeId) {
    return {
      nextEntry: currentEntry,
      dataChanged: false,
      flagsChanged: false
    };
  }
  const flagsChanged = currentEntry.state.loading !== nextState.loading || currentEntry.state.stale !== nextState.stale || currentEntry.state.error !== nextState.error;
  const nextHash = nextState.data !== undefined ? hash.create(nextState.data) : undefined;
  const dataChanged = compareHashes(currentEntry.meta.hash, nextHash, hash.mode, logger);
  if (!dataChanged && !flagsChanged) {
    return {
      nextEntry: currentEntry,
      dataChanged: false,
      flagsChanged: false
    };
  }
  const clonedState = Object.assign({}, nextState);
  if (!dataChanged) {
    clonedState.data = currentEntry.state.data;
  }
  return {
    nextEntry: createEntry({
      state: clonedState,
      meta: {
        attachedSince: currentEntry.meta.attachedSince,
        changeContext,
        hash: nextHash,
        params,
        paramLinkTags: currentEntry.meta.paramLinkTags
      }
    }),
    dataChanged,
    flagsChanged
  };
};